$(() => {
  $("#no-existing-students").modal();

  let mainFilter = $("#main_filter_form");
  let filterSubject = $("#filter_subject");

  if (mainFilter.length > 0 && filterSubject.length > 0) {
    let form = mainFilter[0];
    $.ajax({
      type: "GET",
      dataType: "json",
      url: "/subject_entities/autocomplete",
      data: { current_year: form["filter[academic_year]"]?.value, school_id: form["filter[school_id]"]?.value },
      success: function (data) {
        let [result] = data.results || [];
        if (result) {
          let { id, text } = result;
          filterSubject.append(`<option value="${id}" selected>${text}</option>`);
          mainFilter.submit();
        }
      },
    });
  }

  if ($("#results-search").length) {
    $("#filter_school_id").on("change", function () {
      $(this).closest("form").submit();
    });
  }

  if (!$(".results__student").is(":visible")) {
    $("#submit_results_class").attr("disabled", true);
  }

  let wrapper = $(".manage-exam-results");

  $("#r-subject-select", wrapper).select2({
    placeholder: "- Filter by subject -",
  });

  $("#r-school-select", wrapper).select2({
    placeholder: "- Filter by school -",
  });
});
